const { createSelector } = require("reselect");

const selectProviderList = (state) => state["marketplace.payment"].providerList;

const getPaymentProviderList = () =>
  createSelector([selectProviderList], (prf) => prf.data);

const getPaymentProviderListError = () =>
  createSelector([selectProviderList], (prf) => prf.error);

const getPaymentProviderListLoading = () =>
  createSelector([selectProviderList], (prf) => prf.loading);

const selectOzopayPayment = (state) =>
  state["marketplace.payment"].ozopayPayment;

const ozopayPayment = () =>
  createSelector([selectOzopayPayment], (prf) => prf.data);

const ozopayPaymentError = () =>
  createSelector([selectOzopayPayment], (prf) => prf.error);

const ozopayPaymentLoading = () =>
  createSelector([selectOzopayPayment], (prf) => prf.loading);

const selectOzopay = (state) => state["marketplace.payment"].ozopay;

const ozopay = () => createSelector([selectOzopay], (prf) => prf.data);

const ozopayError = () => createSelector([selectOzopay], (prf) => prf.error);

const ozopayLoading = () =>
  createSelector([selectOzopay], (prf) => prf.loading);

module.exports = {
  getPaymentProviderList,
  getPaymentProviderListError,
  getPaymentProviderListLoading,

  ozopayPayment,
  ozopayPaymentError,
  ozopayPaymentLoading,

  ozopay,
  ozopayError,
  ozopayLoading,
};
